import { NgModule } from '@angular/core';
import { VafPaymentDetailComponent } from './vaf-payment-detail.component';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatSortModule } from '@angular/material/sort'
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { VafPaymentCardComponentModule } from '../../components/vaf-payment-card/vaf-payment-card.component.module';
import { TableComponentModule } from '../../components/table/table.component.module';
@NgModule({
    declarations: [
        VafPaymentDetailComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatTooltipModule,
        MatProgressBarModule,
        VafPaymentCardComponentModule,
        TableComponentModule
    ],
    exports: [
        VafPaymentDetailComponent
    ]
})
export class VafPaymentDetailComponentModule { }